<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style>
  .container-items{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    justify-content: center;
  }
  .leaflet-popup-content{
    width: 400px!important;
  }
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4">
        <div class="vx-col w-full">
            <vx-card class="grid-view-item overflow-hidden">
                <div id="container-map" v-if="status_mapa">
                    <l-map :center="center" :zoom="10" ref="mymap" style="height: 100%; overflow: hidden;">
                        <l-control-layers :collapsed="true" :position="layersPosition" :sort-layers="true">
                        </l-control-layers>
                        <l-tile-layer :key="tileProvider.name" :name="tileProvider.name" :url="tileProvider.url" :visible="tileProvider.visible" layer-type="base" v-for="tileProvider in tileProviders">
                        </l-tile-layer>
                        <v-marker-cluster>
                            <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                                <l-icon :icon-anchor="staticAnchor">
                                    <img :src="require(`@/assets/images/markers/${item.status}.svg`)" width="17px;"/>
                                </l-icon>
                                <l-popup>
                                    <div class="popup">
                                      <gridPrincipalItem
                                        img="energy"
                                        :name="item.alias"
                                        :description="$t('Labels.Alias')"
                                      ></gridPrincipalItem>
                                      <vs-divider/>
                                      <div class="container-items">
                                        <valueItem
                                          :value="parseFloat(item.corriente_a || 0).toFixed(2)"
                                          :description="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
                                          img="corriente_a"
                                          unit="A"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.corriente_b || 0).toFixed(2)"
                                          :description="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
                                          img="corriente_b"
                                          unit="A"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.corriente_c || 0).toFixed(2)"
                                          :description="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
                                          img="corriente_c"
                                          unit="A"
                                        ></valueItem>

                                        <valueItem
                                          :value="parseFloat(item.voltaje_a || 0).toFixed(2)"
                                          :description="$tc('Labels.Voltage', 2, { n: 'A' })"
                                          img="voltaje_a"
                                          unit="V"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.voltaje_b || 0).toFixed(2)"
                                          :description="$tc('Labels.Voltage', 2, { n: 'B' })"
                                          img="voltaje_b"
                                          unit="V"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.voltaje_c || 0).toFixed(2)"
                                          :description="$tc('Labels.Voltage', 2, { n: 'C' })"
                                          img="voltaje_c"
                                          unit="V"
                                        ></valueItem>

                                        <valueItem
                                          :value="parseFloat(item.potencia_a || 0).toFixed(2)"
                                          :description="$tc('Labels.Power', 2, { n: 'A' })"
                                          img="potencia_a"
                                          unit="W"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.potencia_b || 0).toFixed(2)"
                                          :description="$tc('Labels.Power', 2, { n: 'B' })"
                                          img="potencia_b"
                                          unit="W"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.potencia_c || 0).toFixed(2)"
                                          :description="$tc('Labels.Power', 2, { n: 'C' })"
                                          img="potencia_c"
                                          unit="W"
                                        ></valueItem>

                                        <valueItem
                                          :value="parseFloat(item.factor_a || 0).toFixed(2)"
                                          :description="$tc('Labels.Factor', 2, { n: 'A' })"
                                          img="factor_a"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.factor_b || 0).toFixed(2)"
                                          :description="$tc('Labels.Factor', 2, { n: 'B' })"
                                          img="factor_b"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.factor_c || 0).toFixed(2)"
                                          :description="$tc('Labels.Factor', 2, { n: 'C' })"
                                          img="factor_c"
                                        ></valueItem>
                                        <valueItem
                                            :value="parseFloat(item.energia || 0).toFixed(2)"
                                            :description="$tc('Labels.Energy', 2, { n: 'A' })"
                                            img="kws"
                                            unit="W"
                                          ></valueItem>
                                      </div>
                                      <vs-divider/>
                                      <valueItem
                                        :value="item.updated_at.split(' ')[0]"
                                        :description="item.updated_at.split(' ')[1]"
                                        img="fecha"
                                      ></valueItem>
                                      <alertItem :status="item.status === 1? true: false"></alertItem>
                                      <div class="text-center"><vs-button color="primary"  size="small" @click="deviceInformation(item.id)">Ver Más</vs-button></div>
                                </div>
                                </l-popup>
                            </l-marker>
                        </v-marker-cluster>
                    </l-map>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import { request } from '@/request.js'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  name: 'mapa',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlLayers,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    gridPrincipalItem,
    valueItem,
    alertItem
  },
  data () {
    return {
      response: [],
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      markers: [],
      status_mapa: false,
      status_heat: false
    }
  },
  methods: {
    async getMapa () {
      this.$vs.loading()
      const params = {
        url: 'modelo/energies/map',
        method: 'GET'
      }
      await request(params).then(data => {
        data = data.data.data
        const positions = []
        for (const value of data) {
          positions.push([value.location.split(',')[0], value.location.split(',')[1]])
          this.markers.push({
            position: { lat: value.location.split(',')[0], lng: value.location.split(',')[1] },
            alias: value.alias,
            status: value.status,
            updated_at: value.updated_at,
            id: value.energies_id,
            energia: value.energia,
            corriente_a: value.corriente_a,
            corriente_b: value.corriente_b,
            corriente_c: value.corriente_c,
            voltaje_a: value.voltaje_a,
            voltaje_b: value.voltaje_b,
            voltaje_c: value.voltaje_c,
            potencia_a: value.potencia_a,
            potencia_b: value.potencia_b,
            potencia_c: value.potencia_c,
            factor_a: value.factor_a,
            factor_b: value.factor_b,
            factor_c: value.factor_c,
            draggable: false,
            visible: true
          })
        }

        this.status_mapa = true
        this.$vs.loading.close()
        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          maps.addControl(new L.Control.Fullscreen())
          maps.fitBounds(positions)
        }, 1000)
      })
    },

    deviceInformation (uuid) {
      window.location.href = `/energy/detail/${uuid}`
    }

  },
  sockets: {
    energie (payload) {
      this.markers.forEach(markerToModify => {
        if (markerToModify.id === payload.uuid) {
          markerToModify.corriente_a = payload.corriente_a
          markerToModify.corriente_b = payload.corriente_b
          markerToModify.corriente_c = payload.corriente_c
          markerToModify.energia = payload.energia
          markerToModify.energia_a = payload.energia_a
          markerToModify.energia_b = payload.energia_b
          markerToModify.energia_c = payload.energia_c
          markerToModify.factor_a = payload.factor_a
          markerToModify.factor_b = payload.factor_b
          markerToModify.factor_c = payload.factor_c
          markerToModify.potencia_a = payload.potencia_a
          markerToModify.potencia_b = payload.potencia_b
          markerToModify.potencia_c = payload.potencia_c
          markerToModify.potencia_r_a = payload.potencia_r_a
          markerToModify.potencia_r_b = payload.potencia_r_b
          markerToModify.potencia_r_c = payload.potencia_r_c
          markerToModify.voltaje_a = payload.voltaje_a
          markerToModify.voltaje_b = payload.voltaje_b
          markerToModify.voltaje_c = payload.voltaje_c
          markerToModify.status = payload.status
          markerToModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getMapa()
  }

}
</script>
